//调解员数据表
export function dataInJs() {
    function getRandomInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min) + min); //不包括最大值，包括最小值
      }
       
      var randomInt = getRandomInt(1, 40);
	var List= [
        {
            imgName: require('../../assets/image/llz.jpg'),//照片
            name: '林寅总',//名称
            MediationSuccessful: 45,//调解成功
            NumberOfCases: 48,//调解案件
            hrefs: 'https://tiaojie.court.gov.cn/organ/QutAQStGusQfnhRe',//点击图片跳转的地址
            data: [
                '民间借贷纠纷',
                '物业服务合同纠纷',
                '其他合同纠纷',
                '与公司有关纠纷'
            ]
        },
        {
            imgName: require('../../assets/image/hhx.jpg'),//照片
            name: '胡涵信',//名称
            MediationSuccessful: 55,//调解成功
            NumberOfCases: 58,//调解案件
            hrefs: 'https://tiaojie.court.gov.cn/organ/QutAQStGusQfnhRe',//点击图片跳转的地址
            data: [
                '民间借贷纠纷',
                '物业服务合同纠纷',
                '其他合同纠纷',
                '消费者权益保护纠纷'
            ]
        },
        {
            imgName: require('../../assets/image/应龙材.jpg'),//照片
            name: '应龙材',//名称
            MediationSuccessful: 36,//调解成功
            NumberOfCases: 40,//调解案件
            hrefs: '',//点击图片跳转的地址
            data: [
                '买卖合同纠纷',
                '民间借贷纠纷',
                '租赁合同纠纷'
            ]
        },
        {
            imgName: require('../../assets/image/步童.jpg'),//照片
            name: '步童',//名称
            MediationSuccessful: 17,//调解成功
            NumberOfCases: 20,//调解案件
            hrefs: '',//点击图片跳转的地址
            data: [
                '买卖合同纠纷',
                '民间借贷纠纷',
                '租赁合同纠纷'
            ]
        },
     
        {
            imgName: require('../../assets/image/蒋钰韩.jpg'),//照片
            name: '蒋钰韩',//名称
            MediationSuccessful: 17,//调解成功
            NumberOfCases: 24,//调解案件
            hrefs: '',//点击图片跳转的地址
            data: [
                '买卖合同纠纷',
                '民间借贷纠纷',
                '租赁合同纠纷'
            ]
        },
        {
            imgName: require('../../assets/image/cxr.jpg'),//照片
            name: '柴欣如',//名称
            MediationSuccessful: 25,//调解成功
            NumberOfCases: 27,//调解案件
            hrefs: '',//点击图片跳转的地址
            data: [
                '买卖合同纠纷',
                '民间借贷纠纷',
                '租赁合同纠纷'
            ]
        },
        {
            imgName: require('../../assets/image/xll1.jpg'),//照片
            name: '许林林',//名称
            MediationSuccessful: 27,//调解成功
            NumberOfCases: 31,//调解案件
            hrefs: '',//点击图片跳转的地址
            data: [
                '买卖合同纠纷',
                '民间借贷纠纷',
                '租赁合同纠纷'
            ]
        },
        {
            imgName: require('../../assets/image/yjh.jpg'),//照片
            name: '姚菁涵',//名称
            MediationSuccessful: 19,//调解成功
            NumberOfCases: 26,//调解案件
            hrefs: '',//点击图片跳转的地址
            data: [
                '买卖合同纠纷',
                '民间借贷纠纷',
                '租赁合同纠纷'
            ]
        },
        {
            imgName: require('../../assets/image/zyf.jpg'),//照片
            name: '张云芳',//名称
            MediationSuccessful: 15,//调解成功
            NumberOfCases: 17,//调解案件
            hrefs: '',//点击图片跳转的地址
            data: [
                '买卖合同纠纷',
                '民间借贷纠纷',
                '租赁合同纠纷'
            ]
        },
        {
            imgName: require('../../assets/image/zyq.jpg'),//照片
            name: '张云倩',//名称
            MediationSuccessful: 17,//调解成功
            NumberOfCases: 19,//调解案件
            hrefs: '',//点击图片跳转的地址
            data: [
                '买卖合同纠纷',
                '民间借贷纠纷',
                '租赁合同纠纷'
            ]
        },
        {
            imgName: require('../../assets/image/zdc.jpg'),//照片
            name: '周东晨',//名称
            MediationSuccessful: 18,//调解成功
            NumberOfCases: 21,//调解案件
            hrefs: '',//点击图片跳转的地址
            data: [
                '买卖合同纠纷',
                '民间借贷纠纷',
                '租赁合同纠纷'
            ]
        },
        {
            imgName: require('../../assets/image/李华鑫.jpg'),//照片
            name: '李华鑫',//名称
            MediationSuccessful: 19,//调解成功
            NumberOfCases: 23,//调解案件
            hrefs: '',//点击图片跳转的地址
            data: [
                '买卖合同纠纷',
                '民间借贷纠纷',
                '租赁合同纠纷'
            ]
        },
        {
            imgName: require('../../assets/image/李佳校.jpg'),//照片
            name: '李佳校',//名称
            MediationSuccessful: 16,//调解成功
            NumberOfCases: 19,//调解案件
            hrefs: '',//点击图片跳转的地址
            data: [
                '买卖合同纠纷',
                '民间借贷纠纷',
                '租赁合同纠纷'
            ]
        },
        {
            imgName: require('../../assets/image/李姗.jpg'),//照片
            name: '李姗',//名称
            MediationSuccessful: 49,//调解成功
            NumberOfCases: 50,//调解案件
            hrefs: '',//点击图片跳转的地址
            data: [
                '买卖合同纠纷',
                '民间借贷纠纷',
                '租赁合同纠纷'
            ]
        },
        {
            imgName: require('../../assets/image/李泽涛.jpg'),//照片
            name: '李泽涛',//名称
            MediationSuccessful: 20,//调解成功
            NumberOfCases: 24,//调解案件
            hrefs: '',//点击图片跳转的地址
            data: [
                '买卖合同纠纷',
                '民间借贷纠纷',
                '租赁合同纠纷'
            ]
        },
        {
            imgName: require('../../assets/image/刘佳骏.jpg'),//照片
            name: '刘佳骏',//名称
            MediationSuccessful: 23,//调解成功
            NumberOfCases: 25,//调解案件
            hrefs: '',//点击图片跳转的地址
            data: [
                '买卖合同纠纷',
                '民间借贷纠纷',
                '租赁合同纠纷'
            ]
        },
        {
            imgName: require('../../assets/image/卢梦梦.jpg'),//照片
            name: '卢梦梦',//名称
            MediationSuccessful: 19,//调解成功
            NumberOfCases: 21,//调解案件
            hrefs: '',//点击图片跳转的地址
            data: [
                '买卖合同纠纷',
                '民间借贷纠纷',
                '租赁合同纠纷'
            ]
        },
     
        {
            imgName: require('../../assets/image/司成祥.jpg'),//照片
            name: '司成祥',//名称
            MediationSuccessful: 27,//调解成功
            NumberOfCases: 30,//调解案件
            hrefs: '',//点击图片跳转的地址
            data: [
                '买卖合同纠纷',
                '民间借贷纠纷',
                '租赁合同纠纷'
            ]
        },
        {
            imgName: require('../../assets/image/王金荣.jpg'),//照片
            name: '王金荣',//名称
            MediationSuccessful: 11,//调解成功
            NumberOfCases: 14,//调解案件
            hrefs: '',//点击图片跳转的地址
            data: [
                '买卖合同纠纷',
                '民间借贷纠纷',
                '租赁合同纠纷'
            ]
        },
        {
            imgName: require('../../assets/image/王越.jpg'),//照片
            name: '王越',//名称
            MediationSuccessful: 35,//调解成功
            NumberOfCases: 39,//调解案件
            hrefs: '',//点击图片跳转的地址
            data: [
                '买卖合同纠纷',
                '民间借贷纠纷',
                '租赁合同纠纷'
            ]
        },
        {
            imgName: require('../../assets/image/吴兰锁.jpg'),//照片
            name: '吴兰锁',//名称
            MediationSuccessful: 20,//调解成功
            NumberOfCases: 25,//调解案件
            hrefs: '',//点击图片跳转的地址
            data: [
                '买卖合同纠纷',
                '民间借贷纠纷',
                '租赁合同纠纷'
            ]
        },
        {
            imgName: require('../../assets/image/阴寓凡.jpg'),//照片
            name: '阴寓凡',//名称
            MediationSuccessful: 26,//调解成功
            NumberOfCases: 28,//调解案件
            hrefs: '',//点击图片跳转的地址
            data: [
                '买卖合同纠纷',
                '民间借贷纠纷',
                '租赁合同纠纷'
            ]
        },
        {
            imgName: require('../../assets/image/张广燕.jpg'),//照片
            name: '张广燕',//名称
            MediationSuccessful: 21,//调解成功
            NumberOfCases: 30,//调解案件
            hrefs: '',//点击图片跳转的地址
            data: [
                '买卖合同纠纷',
                '民间借贷纠纷',
                '租赁合同纠纷'
            ]
        },
        {
            imgName: require('../../assets/image/张佳.jpg'),//照片
            name: '张佳',//名称
            MediationSuccessful: 17,//调解成功
            NumberOfCases: 21,//调解案件
            hrefs: '',//点击图片跳转的地址
            data: [
                '买卖合同纠纷',
                '民间借贷纠纷',
                '租赁合同纠纷'
            ]
        },
        {
            imgName: require('../../assets/image/张丽丽.jpg'),//照片
            name: '张丽丽',//名称
            MediationSuccessful: 8,//调解成功
            NumberOfCases: 10,//调解案件
            hrefs: '',//点击图片跳转的地址
            data: [
                '买卖合同纠纷',
                '民间借贷纠纷',
                '租赁合同纠纷'
            ]
        },
        
    ];
	return List;
}
